// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@flip/XDL/types";
import { color, styledScrollbar } from "@flip/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import OverflowMenuPresentationPropsDefault from "@insite/mobius/OverflowMenu/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...OverflowMenuPresentationPropsDefault,
        mergeCss: true,
        buttonProps: {
            ...OverflowMenuPresentationPropsDefault?.buttonProps,
            css: css`
                &,
                &:hover,
                &:focus {
                    border: 0;
                    min-height: 40px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-left: 5px;
                }

                &:hover:not(:disabled),
                &:focus:not(:disabled) {
                    background: ${color("common.ui4")};
                    ${IconWrapper} {
                        color: ${color("common.ui1")};
                    }
                }
            `,
        },
        cssOverrides: {
            menu: css`
                overflow-y: auto;
                ${styledScrollbar(4)}
            `,
            menuItem: css`
                &:hover {
                    background: ${color("common.ui2")};
                }
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
